module.exports = __webpack_public_path__ + "static/media/N-Mall-005.d5d62ef4.webp";